import { Box, Typography } from '@mui/material';
import NewLogo from '../../../assets/images/Layer_1.png';

type LoginHeroProps = {
  isMobile: boolean;
};

export function LoginHero({ isMobile }: LoginHeroProps) {
  if (!isMobile) {
    return (
      <Box
        sx={{
          width: '45%',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          paddingLeft: '60px',
          paddingRight: '60px',
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            width: '80%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ width: '100%' }}>
            <Box
              component="div"
              sx={{
                width: '45%',
                height: '45%',
                backgroundImage: `url(${NewLogo})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                marginBottom: '10px',
              }}
            />
            <Box
              sx={{
                height: { md: '290px', lg: '270px' },
                width: '100%',
              }}
            >
              <Box sx={{ width: '85%' }}>
                <Typography sx={{ fontSize: '32px', fontWeight: 'bolder' }}>A Little About Us!</Typography>
                <br />
                <Typography>
                  LedgerX is an accounting software specially designed to solve the daily business needs of a well
                  established organization. You can review your daily entries and store bills in the cloud. We
                  constantly strive to improve our product and welcome your feedback at&nbsp;
                  <a href="mailto:support@ledgerx.biz" style={{ textDecoration: 'none' }}>
                    &nbsp;support@ledgerx.biz
                  </a>
                  .
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: { xs: '90%', sm: '80%', md: '45%', lg: '45%' },
        marginBottom: { xs: '30px', sm: '60px', md: '0px' },
      }}
    >
      <Box
        sx={{
          minHeight: '130px',
          width: '100%',
          backgroundImage: `url(${NewLogo})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      />
      <Typography
        variant="h4"
        sx={{
          marginTop: '10px',
          color: '#3A3A3A',
          marginBottom: '15px',
          textAlign: { xs: 'justify', md: 'left' },
          fontWeight: 700,
          fontFamily: 'sans-serif',
        }}
      >
        A Little About Us!
      </Typography>
      <Typography
        sx={{
          color: '#3A3A3A',
          marginBottom: '15px',
          textAlign: { xs: 'justify', md: 'left' },
          fontFamily: 'sans-serif',
        }}
      >
        LedgerX is an accounting software specially designed to solve the daily business needs of an well established
        organization, You can review your daily entries and store bills in the cloud.
      </Typography>
    </Box>
  );
}
